import { useQuery } from '@tanstack/react-query';
import { ticketService } from '../services/ticketService';
import type { Ticket } from '../types/ticket.types';

const EMPTY: Ticket[] = [];

/** Phase 6: see useServices for why. Exported shape unchanged. */
export function useTickets() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['support', 'tickets'],
    queryFn: () => ticketService.list(),
  });

  return {
    data: data ?? EMPTY,
    isLoading,
    error: (error as Error | null) ?? null,
    refetch,
  };
}
